import { el } from './utils';
import type { EmbedPoll } from './utils';

export function computeCounts(poll: EmbedPoll, ids: string[]): Record<string, { yes: number; maybe: number; no: number }> {
	const counts: Record<string, { yes: number; maybe: number; no: number }> = {};
	for (const id of ids) {
		counts[id] = { yes: 0, maybe: 0, no: 0 };
	}
	for (const p of poll.participants) {
		for (const v of p.votes) {
			if (counts[v.slot_id]) {
				if (v.response === 'yes') counts[v.slot_id].yes++;
				else if (v.response === 'maybe') counts[v.slot_id].maybe++;
				else if (v.response === 'no') counts[v.slot_id].no++;
			}
		}
	}
	return counts;
}

export function renderResultBar(c: { yes: number; maybe: number; no: number }, maxVotes: number): HTMLElement {
	const total = c.yes + c.maybe + c.no;
	const yesW = maxVotes > 0 ? (c.yes / maxVotes) * 100 : 0;
	const maybeW = maxVotes > 0 ? (c.maybe / maxVotes) * 100 : 0;
	const noW = maxVotes > 0 ? (c.no / maxVotes) * 100 : 0;

	const bar = el('div', { class: 'dte-bar-track' }, [
		el('div', { class: 'dte-bar-yes', style: `width:${yesW}%` }),
		el('div', { class: 'dte-bar-maybe', style: `width:${maybeW}%` }),
		el('div', { class: 'dte-bar-no', style: `width:${noW}%` })
	]);

	const count = el('div', { class: 'dte-count' }, [
		total > 0 ? `${c.yes} yes` : ''
	]);

	return el('div', { class: 'dte-result' }, [bar, count]);
}

export function renderBadges(poll: EmbedPoll, slotId: string): HTMLElement | null {
	const badges: HTMLElement[] = [];

	for (const p of poll.participants) {
		const vote = p.votes.find((v) => v.slot_id === slotId);
		if (vote && vote.response !== 'no') {
			badges.push(
				el('span', { class: `dte-badge dte-badge-${vote.response}` }, [p.name])
			);
		}
	}

	if (badges.length === 0) return null;

	return el('div', { class: 'dte-badges' }, badges);
}
